const ErrorUtil = {
  pushErrorToTeliaRum(error, message) {
    if (window.TeliaRum) {
      this.supplementErrorStack(error);
      return window.TeliaRum.sendError(error, message);
    }
  },
  pushErrorToTeliaRumAndLog(error, message) {
    this.pushErrorToTeliaRum(error, message);
    console.error(error);
  },
  supplementErrorStack(error) {
    var _a, _b, _c;
    if (error == null ? void 0 : error.config) {
      const e = error;
      error.stack = "".concat(e == null ? void 0 : e.message, ", ").concat((_a = e == null ? void 0 : e.config) == null ? void 0 : _a.method, ":").concat((_b = e == null ? void 0 : e.config) == null ? void 0 : _b.url, " ").concat(((_c = e == null ? void 0 : e.response) == null ? void 0 : _c.status) || "", " \n ").concat(e.stack);
    }
  }
};
export {
  ErrorUtil as default
};
